import Title from "components/Title";
import * as S from "./styles";
import AgentType from "utils/agentType";
import TableFilters from "components/TableFilters";
import TableFilterHistory from "components/TableFilterHistory";


function Filters() {
  const agentType = AgentType();

  return (
    <>
      <S.Box>
        <Title
          titleText="Gerenciamento de filtros"
          subtitleTexts={["Início", "Gerenciamento de filtros"]}
        />
        {/* <S.DescriptionBox>
          <p>
          Essa tela permite que o gestor configure de forma simples os filtros disponíveis, ajustando as regras conforme as necessidades do programa, sem depender de intervenções técnicas.
          </p>
        </S.DescriptionBox> */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 20
          }}
        >
          <TableFilters />
          {['1'].includes(agentType) &&
            <TableFilterHistory />}
        </div>
      </S.Box>
    </>
  );
}

export default Filters;
